import { Navigate } from "react-router";
import { Constants } from "../utils/constants/Constants";
import { EVENTS } from "../utils/constants/APIURL.constants";

export const Token = () => {
  let adminUser = JSON.parse(
    localStorage.getItem(`${Constants.LOCAL_STORAGE_KEY_ADMIN_USER}`)
  );
  let idToken = adminUser?.access;
  if (!!idToken) {
    idToken = Constants.TEXT_BEARER + Constants.TEXT_EMPTY + idToken;
  }
  return { Authorization: idToken };
};

export const isAuthenticated = () => {
  const adminUser = JSON.parse(
    localStorage.getItem(`${Constants.LOCAL_STORAGE_KEY_ADMIN_USER}`)
  );
  let auth = adminUser?.access;

  return auth;
};

export const logout = (next) => {
  localStorage.removeItem(`${Constants.LOCAL_STORAGE_KEY_ID_TOKEN}`);
  localStorage.removeItem(`${Constants.LOCAL_STORAGE_KEY_ADMIN_USER}`);
  next();
};

export const getQueryUrl = (params) => {
  var queryString = getCleanQueryString(params);
  return queryString;
};

export const getCleanQueryString = (params) => {
  var { ...query } = params;
  return Object.keys(query)
    .filter((key) => query[key] !== Constants.TEXT_EMPTY)
    .map((keyName) => keyName + Constants.SYMBOL_EQUAL + query[keyName])
    .join(Constants.SYMBOL_AMPERSAND);
};
